import React from 'react';
import Layout from '../../components/Layout';
import Book from './Book';
import NotFound from '../notFound/NotFound';
import moment from 'moment';

//Actions
import { bookingProcess } from '../../actions/booking/bookingProcess';

//import { getRedirectURL } from '../../helpers/formatURL';

//import { url } from '../../config';

/* import history from '../../core/history'; */

const title = 'Booking';

export default {

  path: '/book/:hostingId',

  async action({ store, params, query }) {

    // From Redux Store
    let hostingId = params.hostingId;
    let originalIsAuthenticated = Boolean(store.getState().runtime.isAuthenticated);
    let bookingData = store.getState().book.data;
    let bookDetails = store.getState().book.bookDetails;

    // Check listId is provided
    if (!hostingId) {
      return {
        title,
        component: <Layout><NotFound title={title} /></Layout>,
        status: 404
      };
    }

    //Test redirect
    /* if( typeof document !== 'undefined' && typeof window !== 'undefined' && typeof query.referred === 'undefined' ) {
      if( !/^https:\/\/carrytheone\.co\.uk/i.test(document.referrer) ) {
        window.location = 'https://www.carrytheone.co.uk/redirect.php?url=' + encodeURIComponent(url + '/book/' + hostingId + '?referred=1' + ( query.bookDetails ? '&bookDetails=' + encodeURIComponent(query.bookDetails) : '' ));
        return {};
      }
    } */

    if( !bookDetails && typeof query.bookDetails === 'string' ) {
      let bookingDetails = JSON.parse(query.bookDetails);
      if( bookingDetails ) {
        if( ['listId', 'guests', 'useFreeTrial', 'monthlyPass', 'monthPass', 'startDate', 'endDate', 'ptm'].every(e => typeof bookingDetails[e] !== 'undefined') ) {
          switch( true ) { case true:
            if( typeof bookingDetails.checkoutReturn !== 'undefined' && ( typeof bookingDetails.checkoutReturn !== 'boolean' ||
                                                                          typeof bookingDetails.reservationId !== 'number' ||
                                                                          !bookingDetails.reservationId ||
                                                                          typeof bookingDetails.paymentIntentId !== 'string' ||
                                                                          !bookingDetails.paymentIntentId.length )) break;
            if( typeof bookingDetails.guests !== 'number' ) break;
            if( typeof bookingDetails.useFreeTrial !== 'boolean' ) break;
            if( typeof bookingDetails.monthlyPass !== 'boolean' ) break;
            if( typeof bookingDetails.monthPass !== 'boolean' ) break;
            if( typeof bookingDetails.ptm !== 'boolean' ) break;

            let monthlyPass = bookingDetails.monthlyPass;
            
            let today = moment(new Date()).format("YYYY-MM-DD");
            let startDate = moment(bookingDetails.startDate).format("YYYY-MM-DD");
            let endDate = bookingDetails.endDate ? moment(bookingDetails.endDate).format("YYYY-MM-DD") : null;
            
            if ((startDate < today) || !monthlyPass && endDate < today) {
              break;
            } else if(!monthlyPass && startDate > endDate) {
              break;
            } else if((moment(startDate).isValid() == false) || !monthlyPass && (moment(endDate).isValid() == false)) {
              break;
            }

            if( typeof window === 'undefined' ) { //forces client-side rendering
              return {
                title,
                component: <Layout><Book title={title} listId={hostingId} loading={true} /></Layout>
              };
            }

            startDate = moment(startDate);
            endDate = endDate ? moment(endDate) : null;

            await store.dispatch(bookingProcess({...bookingDetails, startDate, endDate}));
            bookingData = store.getState().book.data;
            bookDetails = store.getState().book.bookDetails;
          }
        }
      }
    }

    if( typeof window === 'undefined' ) { //forces client-side rendering
      return {
        title,
        component: <Layout><Book title={title} listId={hostingId} loading={true} /></Layout>
      };
    }
    //#region testing
    /*else if( typeof document !== 'undefined' && typeof window !== 'undefined' && typeof query.referred === 'undefined' ) {
      if( !/^https:\/\/carrytheone\.co\.uk/i.test(document.referrer) ) {
        window.location = 'https://www.carrytheone.co.uk/redirect.php?url=' + encodeURIComponent(url + '/book/' + hostingId + '?referred=1');
        return {};
      }
    } */

    // Check authentication
    /* if (!isAuthenticated) {
      if (bookDetails && bookingData) {
        return { redirect: '/login?refer=' + encodeURIComponent('/book/' + hostingId + '?bookDetails=' + encodeURIComponent(JSON.stringify(bookDetails))) };
      }
      else if( hostingId ) {
        return { redirect: '/login?refer=' + encodeURIComponent('/rooms/' + hostingId) };
      }
      else {
        return { redirect: '/login' };
      }
    }*/
    //#endregion

    // Check redux store for booking data
    if (!bookingData || !bookDetails) {
      return { redirect: '/rooms/' + hostingId };
    }

    return {
      title,
      component: <Layout><Book title={title} listId={hostingId} loading={false} originalIsAuthenticated={originalIsAuthenticated} /></Layout>,
    };
  },

};


// WEBPACK FOOTER //
// src/routes/book/index.js